import type { HttpRequestConfig } from "@kalodata/http";
import { appendUrlParams } from "@utils/url";

const AUTH_SAVED_PARAMS_KEY = "auth_saved_params";
const LEGACY_QUERY_KEYS = ["bizCode", "tc"] as const;

type SavedUrlParams = Partial<Record<(typeof LEGACY_QUERY_KEYS)[number], string>>;

const parseSavedUrlParams = (): SavedUrlParams => {
  const raw = sessionStorage.getItem(AUTH_SAVED_PARAMS_KEY);
  if (!raw) {
    return {};
  }
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) {
      return {};
    }
    return parsed as SavedUrlParams;
  } catch {
    return {};
  }
};

export const applyLegacyRequestQuery = <TMeta = unknown, TContext = unknown>(
  request: HttpRequestConfig<unknown, TMeta, TContext>,
): HttpRequestConfig<unknown, TMeta, TContext> => {
  if (!request.url) {
    return request;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const savedParams = parseSavedUrlParams();
  const nextUrl = appendUrlParams(
    request.url,
    LEGACY_QUERY_KEYS.map((key) => ({
      key,
      value: searchParams.get(key) ?? savedParams[key],
    })),
  );

  return {
    ...request,
    url: nextUrl,
  };
};
